import * as React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { ControlLabel } from 'react-bootstrap';
import { isPresent } from 'helpers/string_helpers';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-solid-svg-icons';

import './styles/filters.scss';

class CityFilter extends React.Component {
  static propTypes = {
    cities: PropTypes.arrayOf(PropTypes.string).isRequired,
    currentCity: PropTypes.string,
    onChange: PropTypes.func.isRequired
  };

  state = {
    active: false,
  };

  inputRef = React.createRef();
  wrapperRef = React.createRef();

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = () => {
    const { onChange, currentCity } = this.props;
    if (isPresent(currentCity)) {
      onChange(currentCity, "cities");
    }

    this.setState({ active: false  });
  }

  handleKeyPress = (e) => {
    const { onChange, currentCity } = this.props;
    if (e.key === "Enter" && isPresent(currentCity)) {
      onChange(currentCity, "cities");
    }
  }

  handleRemove = (city) => {
    const { onChange } = this.props;
    onChange(city, "cities");
  }

  renderRemoveLink(city) {
    return (
      <React.Fragment>
        &nbsp;
        <FontAwesomeIcon
          className="remove-icon clickable"
          icon={faTimes}
          name="remove-icon"
          size="sm"
          onClick={() => this.handleRemove(city)}
        />
      </React.Fragment>
    );
  }

  renderCityChip = (city) => {
    return (
      <div className="city-box" key={city}>
        <div className="text-capitalize d-flex w-100 p-2">
          <div className="w-100">{city}</div>
          {this.renderRemoveLink(city)}
        </div>
      </div>
    );
  }

  renderCities() {
    const { cities } = this.props;

    if (cities.length > 0) {
      return (
        <div className="cities-bucket">
          {cities.map(c => this.renderCityChip(c))}
        </div>
      );
    }
  }

  renderCityInput() {
    const { cities, currentCity, onChange } = this.props;

    return (
      <input
        autoComplete="off"
        autoFocus={false}
        className="city-input mt-1 borderless disable-outline"
        placeholder={cities.length === 0 ? "City" : "Enter another city"}
        ref={this.inputRef}
        value={currentCity}
        onChange={e => onChange(e, "currentCity")}
        onClick={() => this.setState({ active: true })}
        onKeyPress={this.handleKeyPress}
      />
    );
  }

  render() {
    const { active } = this.state;
    const { cities } = this.props;


    const containerClass = classNames({
      'cities-container': true,
      'form-control': true,
      'active': active,
      'h-100': cities.length > 0,
      'd-inline-flex': cities.length === 0
    });

    return (
      <React.Fragment>
        <ControlLabel>City</ControlLabel>
        <div
          className={containerClass}
          ref={this.wrapperRef}
        >
          {this.renderCities()}
          {this.renderCityInput()}
        </div>
      </React.Fragment>
    );
  }
}

export default CityFilter;
